
/**
 * Module dependencies.
 */

import { AmbientProps } from 'src/types/ambients';
import { fetchAmbients, paginationLimit } from './fetch-ambients';
import { useInfiniteQuery } from 'react-query';
import { useRouter } from 'next/router';

/**
 * Export `InitialData` type.
 */

export type InitialData = {
  pageParams: number[],
  pages: Array<{
    data: AmbientProps[],
    nextPage: number | null,
    total: number
  }>
};

/**
 * `Options` type.
 */

type Options = {
  filterParams: any,
  initialData?: InitialData | null
};

/**
 * Action type.
 */

const actionType = ({ locale }): string => {
  return `${locale}-ambients`;
};

/**
 * `useAmbients` hook.
 */

function useAmbients({ filterParams, initialData }: Options) {
  const { locale } = useRouter();
  const result = useInfiniteQuery(
    actionType({ locale }),
    ({ pageParam = 1 }) => fetchAmbients({
      locale,
      params: { limit: paginationLimit, page: pageParam, ...filterParams }
    }), {
      getNextPageParam: (lastPage, allPages) => {
        const pageLimit = Math.ceil(allPages[0]?.total / paginationLimit);
        const nextPage = lastPage?.nextPage;

        return nextPage <= pageLimit ? nextPage : false;
      },
      initialData
    }
  );

  return result;
}

/**
 * Export `useAmbients` hook.
 */

export default useAmbients;
